import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=30463db4&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=30463db4&prod&lang=scss&scoped=true"
import style1 from "./Group.vue?vue&type=style&index=1&id=30463db4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30463db4",
  null
  
)

export default component.exports